import { forwardRef } from "react";

import Icon from "@/components/Icon";
import AddIcon from "./AddIcon.svg.jsx";

const BinderIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={AddIcon} {...props} />;
});

export default BinderIcon;
